import React from 'react'
import { VStack, Link, Text, Button, Heading, Container } from '@chakra-ui/react'

import { WizardStepForm } from 'components'

export const FormSubmissionIntroStep = props => (
  <WizardStepForm {...props} hideNavigation justify='center'>
    <Heading size='4xl' textAlign='center' my={5}>
      Bem-vindo!
    </Heading>
    <Container my={5}>
      <VStack spacing={5}>
        <Text fontSize='lg' align='center'>
          A presente ferramenta constitui um meio para a avaliação de risco associado à conceção,
          implementação e utilização de um sistema de IA e atua na vertente de identificação e de
          mitigação, de modo a garantir uma IA Responsável.
        </Text>
        <Text fontSize='lg' align='center'>
          Esta destina-se a todas as pessoas e entidades, utilizadores ou criadores, e pode ser
          aplicada a qualquer etapa do ciclo de um sistema de IA, desde a sua formulação à sua
          utilização.
        </Text>
        <Text fontSize='lg' align='center'>
          A ferramenta contempla três fases: a análise da suscetibilidade de projetos de IA,
          sistemas inteligentes ou algoritmos; a comparação de resultados com referências nacionais
          e sectoriais; e as recomendações, em concordância com o nível de maturidade estimado.
        </Text>
        <Text fontSize='lg' align='center'>
          A análise advém de um conjunto de questões e ponderações sustentadas nas 5 dimensões
          subjacentes a uma IA Responsável, isto é, na Responsabilização, Transparência,
          Explicabilidade, Justiça e Ética. No final é gerado um Relatório de Avaliação que é
          acompanhado de um conjunto de recomendações que são complementadas com sugestões de
          leituras.
        </Text>
        <Button size='lg' type='submit'>
          Iniciar
        </Button>
        <Link href='https://ia.tic.gov.pt'>
          Cancelar
        </Link>
      </VStack>
    </Container>
  </WizardStepForm>
)

export default FormSubmissionIntroStep
